import { useEffect, useState } from 'react'
import { Avatar, Button, Group, Paper, Text } from '@mantine/core'
import { dropHandlers, openFilePicker } from '../lib/fileInputBridge'
import { PROFILE_IMAGE_HINT, profileImageError } from '../lib/profileImageCheck'

// #1078 管理者のユーザー登録/編集フォームのプロフィール写真。
// 実体の <input type="file"> は ERB 側(hidden)にあり、ここはプレビューと「写真を選択」ボタン、
// 画像のドラッグ&ドロップだけを担当する(マイページの AccountHeader と同じ方式。フォーム送信は Rails に任せる)。
export default function AvatarField({ inputId, avatarUrl, name }) {
  const [previewUrl, setPreviewUrl] = useState(null)
  const [fileName, setFileName] = useState(null)
  const [dragging, setDragging] = useState(false)
  const [error, setError] = useState(null)
  const initial = name ? name.trim().charAt(0) : '?'

  useEffect(() => {
    const input = document.getElementById(inputId)
    if (!input) return undefined
    const onChange = () => {
      const file = input.files && input.files[0]
      if (!file) return
      // 送信前に拡張子とサイズを見る。NG ならファイルを外し、プレビューも読み込まない
      const message = profileImageError(file)
      setError(message)
      if (message) {
        input.value = ''
        setFileName(null)
        setPreviewUrl(null)
        return
      }
      setFileName(file.name)
      const reader = new FileReader()
      reader.onload = (e) => setPreviewUrl(e.target.result)
      reader.readAsDataURL(file)
    }
    input.addEventListener('change', onChange)
    return () => input.removeEventListener('change', onChange)
  }, [inputId])

  const open = () => openFilePicker(inputId)

  return (
    <Paper
      withBorder
      radius="md"
      p="md"
      {...dropHandlers(inputId, setDragging)}
      style={{
        background: dragging ? 'var(--mantine-color-brand-0)' : 'var(--mantine-color-gray-0)',
        borderColor: dragging ? 'var(--mantine-color-brand-5)' : 'var(--mantine-color-gray-2)',
        borderStyle: dragging ? 'dashed' : 'solid',
        transition: 'background-color 100ms ease, border-color 100ms ease',
      }}
    >
      <Group gap="lg" wrap="nowrap">
        <Avatar
          src={previewUrl || avatarUrl}
          alt={name || ''}
          radius="50%"
          size={96}
          color="brand"
          variant="light"
          onClick={open}
          style={{ flexShrink: 0, cursor: 'pointer', boxShadow: '0 0 0 3px #fff, 0 0 0 4px var(--mantine-color-gray-2)' }}
        >
          {initial}
        </Avatar>
        <div style={{ minWidth: 0 }}>
          <Button
            variant="default"
            size="sm"
            onClick={open}
            leftSection={<span className="material-icons" style={{ fontSize: 18 }} aria-hidden="true">photo_camera</span>}
          >
            写真を選択
          </Button>
          <Text size="xs" c="dimmed" mt={8} lineClamp={2}>
            {fileName ? `${fileName}(保存時にアップロードされます)` : `ここに画像をドロップしても設定できます。${PROFILE_IMAGE_HINT}。未設定の場合はイニシャルが表示されます。`}
          </Text>
          {error && (
            <Text size="xs" c="red" mt={4} role="alert">
              {error}
            </Text>
          )}
        </div>
      </Group>
    </Paper>
  )
}
